import { useState } from "react";
import { Modal } from "../..";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import UIButton from "../atoms/UIButton";
import UICheckbox from "../atoms/UICheckbox";
import UIModalLayout from "../templates/UIModalLayout";

export default function UIModal({ children, btnChildren = "Aceptar", title, markdown = false, onClose, callback, checkbox, checkboxLabel, className, password = false, passwordFunction, twoButtons = false, leftBtnFn, rightBtnFn, noOverflowY = false, loading, noEscape = false }) {
    const { height } = useWindowDimensions()

    const [form, setForm] = useState({ checkboxValue: false, checkboxValueError: false, });

    function handleChange(key, value, regex, valueError) {
        setForm(prevForm => {
            const updatedForm = { ...prevForm };
            updatedForm[key] = value;
            if (regex !== undefined) { const isValid = regex.test(value); updatedForm[valueError] = !isValid; }
            return updatedForm;
        });
    }

    return (
        <Modal>
            <UIModalLayout>
                <div onClick={onClose} className={`fixed filter backdrop-blur-0 top-0 bottom-0 left-0 right-0 bg-[rgba(0,0,0,0.34)] `} />
                <div className={`relative gap-[20px] animate-appear-bottom max-h-[634px]  flex-col w-[90%] max-w-[770px] p-[22px] md:p-[55px] pb-[20px] shadow-xl bg-white min-w-[300px] flex rounded ${className}`}
                    style={{ height: height - 100 }}
                >
                    <img src="/assets/icon/icon_close.svg" alt="close" className={`absolute cursor-pointer top-2 right-2 ${noEscape ? "" : "hidden"}`} onClick={onClose} />
                    <div className="text-[#2A2A2A] pr-[40px] text-[22px] text-Left font-BNPPSquareBold">{title}</div>
                    <div className={`relative flex custom-scroll negative ${noOverflowY ? '': 'overflow-y-auto' }`}>
                        <div className={`text-justify flex flex-col w-full max-w-[770px] text-[#8E8E94] pr-[20px] md:text-[16px] ${markdown && 'markdown-styles'} `}>{children}</div>
                    </div>
                    {checkbox && <div className="flex w-full items-center mt-[20px] mb-[20px]">
                        <UICheckbox initialValue={form.checkboxValue} className={'max-w-full h-auto text-[#58595B]'} handleChange={(e) => handleChange('checkboxValue', e.target.checked)} label={checkboxLabel} />
                    </div>}
                    {!twoButtons && <UIButton disabled={checkbox ? !form.checkboxValue : loading} onClick={callback ? callback : onClose} className='mx-auto uppercase px-[40px]'>{btnChildren}</UIButton>}
                    {twoButtons && 
                        <div className="flex flex-row gap-2 self-center mt-4">
                            <UIButton onClick={leftBtnFn}>Si</UIButton>
                            <UIButton onClick={rightBtnFn}>No</UIButton>
                        </div>
                    }
                    {password && <p className="flex self-center hover:cursor-pointer" onClick={passwordFunction}>¿Olvidaste tu contraseña?</p>}
                </div>
            </UIModalLayout>
        </Modal>
    )
}